// List of approved broker names for the broker sharing page
// Update this list to add more "urls" for the broker sharing page
export const BROKER_NAMES = [
  // Demo urls
  'a',
  'b',
  'c',
  // Real urls
  'actionenterprise',
  'amx',
  'armstrong',
  'arrive',
  'ascentglobal',
  'atlaslogistics',
  'axle',
  'barton',
  'bayandbay',
  'bestbay',
  'bmm',
  'cardinalogistics',
  'choptanktranspo',
  'chrobinson',
  'confiance',
  'cyclone',
  'dagenlogistics',
  'dart',
  'dbglogistics',
  'destinationtransport',
  'evanstranspo',
  'everest',
  'flstranspo',
  'fmg',
  'foxlogistics',
  'freightsolutionsww',
  'fruitionlogistics',
  'glenrose',
  'gptransco',
  'greatamerican',
  'integrityexpress',
  'kchtrans',
  'keller',
  'livelogistics',
  'm2',
  'mvplogistics',
  'nolan',
  'openroad',
  'priority1',
  'prosponsive',
  'r2',
  'rockwellservices',
  'simplelogistics',
  'simsglobal',
  'sonwil',
  'spi',
  'stfreight',
  'suntecktranspo',
  'transportationone',
  'truelogic',
  'truenorth',
  'twelvepoint',
  'uber',
  'ultralogistics',
  'unitedtransportationservices',
];
